import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { ErrorLogComponent } from "./errorlog-component";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
    ],
    declarations: [
        ErrorLogComponent,
    ],
    exports: [
        ErrorLogComponent,
    ]
})
export class ErrorLogModule { }